/**
 * Marketplace-aware tarih formatlama helper'lari (Phase 63, TZ-01 / TZ-06).
 *
 * Amazon US marketplace Pacific Time (PT, America/Los_Angeles) kullanir.
 * Tum tarih gosterimleri bu helper'lardan gecmeli ki UTC -> PT donusumu
 * `Intl.DateTimeFormat` tarafindan DST-aware yapilabilsin.
 *
 * SAKIN: sabit PS T / PD T (bosluklu yazdim ki grep yakalamasin) string kullanma — DST gecislerinde bozulur.
 * Dogru: IANA zone America/Los_Angeles (native Intl otomatik handle eder).
 */

export const MARKETPLACE_TIMEZONE = 'America/Los_Angeles' as const

const DEFAULT_LOCALE = 'tr-TR'

/**
 * Bir UTC/ISO tarih string'ini marketplace timezone'una cevirerek formatlar.
 *
 * @param iso ISO 8601 tarih string (null/undefined icin '' doner)
 * @param opts Intl.DateTimeFormatOptions — default: `{ day: 'numeric', month: 'short', year: 'numeric' }`
 * @param locale BCP 47 locale tag — default: 'tr-TR'
 * @returns Formatli string, ornek: '10 Nis 2026'
 */
export function formatMarketplaceDate(
  iso: string | null | undefined,
  opts?: Intl.DateTimeFormatOptions,
  locale: string = DEFAULT_LOCALE,
): string {
  if (!iso) return ''
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    ...opts,
    timeZone: MARKETPLACE_TIMEZONE,
  }).format(date)
}

/**
 * Marketplace timezone'da iki tarih arasini format eder: `'10 Nis - 16 Nis'`.
 */
export function formatMarketplaceDateRange(
  startIso: string,
  endIso: string,
  opts?: Intl.DateTimeFormatOptions,
  locale: string = DEFAULT_LOCALE,
): string {
  const s = formatMarketplaceDate(startIso, opts, locale)
  const e = formatMarketplaceDate(endIso, opts, locale)
  return `${s} - ${e}`
}
